import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const QuoteWrapper = styled.div.withConfig({
  displayName: "Quote__QuoteWrapper",
  componentId: "sc-1mxfyb9-0"
})(["background-color:", ";position:relative;&::after{content:'';display:block;width:0;height:0;border-left:20px solid transparent;border-right:20px solid transparent;border-top:20px solid ", ";position:absolute;bottom:-20px;margin-left:-20px;left:50%;}p{margin-bottom:0;}"], ({
  theme
}) => theme.color['do-not-use-gypsum'], ({
  theme
}) => theme.color['do-not-use-gypsum']);
const Quote = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(QuoteWrapper, {
    className: "m-y-6 p-all-5",
    children: children
  });
};
export default Quote;